import { StyledGridItem } from './styled';

export type { GridItemProps } from './types';

export const GridItem = StyledGridItem;
